(function () {
  const initAnnouncementSlider = () => {
    document.querySelectorAll('.swiper-announcement-bar').forEach((slider) => {
      if (slider.swiper) return;

      const slides = slider.querySelectorAll('.swiper-slide');

      if (slides.length < 2) return;

      new Swiper(slider, {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      });
    });
  };

  initAnnouncementSlider();

  document.addEventListener('shopify:section:load', initAnnouncementSlider);
})();